<template>
    <div class="cabecalhointerativo">
         <b-container fluid class="cabecalhointerativo-b" style="padding-left: 0px; padding-right: 0px;">

             <mq-layout mq="sm+"> <!--///// Estrategia para telas médias e maior //////////////////////////////////////-->
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////////-->
                <b-row  no-gutters class="cab-int-l1">                  <!-- defaul para tela maior que sm+ -->
                    <b-col sm="2" lg="1" order-sm="1" order-lg="1">
                        <div class="abreMenuInterativo" @click="alternaMenuInterativo">
                            <i class="fas fa-times iconeSetaMenu" v-if="MenuVisivel"></i>
                            <i class="fas fa-bars iconeSetaMenu" v-else></i>
                        </div>
                    </b-col>
                    
                    <b-col sm="6" lg="7" order-sm="3" order-lg="2" class="text-sm-left text-lg-left">
                        <div id="cabecalhointerativo-nome" class="cabecalhointerativo-titulo">{{ limitaTitulo }}</div>
                    </b-col>

                    <b-col sm="4" lg="4" order-sm="9" order-lg="8" class="text-sm-right text-lg-right">
                        <div @click="kesabAkanga" class="cab-int-bot"><inicioInterativo id="inicio-int" /></div>
                        <div class="cab-int-bot"><mainInfo id="mainAlarme" /></div>
                        <div class="cab-int-bot"><Sinos id="sinoAlarme" /></div>
                    </b-col>
                </b-row>
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////////-->
            </mq-layout> <!--///// FINAL - Estrategia para telas médias e maior ///////////////////////////////////////-->

            <!--///////////////////////////////////////////////////////////////////////////////////////////////////////-->
            <mq-layout mq="xs"> <!--///// Estrategia para telas pequenas //////////////////////////////////////////////-->
                <b-row  no-gutters class="cab-int-l1">
                    <b-col cols="2" order="1">
                        <div class="abreMenuInterativo" @click="alternaMenuInterativo">
                            <i class="fas fa-times iconeSetaMenu" v-if="MenuVisivel"></i>
                            <i class="fas fa-bars iconeSetaMenu" v-else></i>
                        </div>
                    </b-col>

                    <b-col cols="10" order="3" class="text-right">
                        <div @click="kesabAkanga" class="cab-int-bot"><inicioInterativo id="inicio-int" /></div>
                        <div class="cab-int-bot"><mainInfo id="mainAlarme" /></div>
                        <div class="cab-int-bot"><Sinos id="sinoAlarme" /></div>
                        <avatarSmall id="avatar-small" class="cab-int-bot" />
                    </b-col>
                </b-row>
            </mq-layout> <!--///// FINAL - Estrategia para telas pequenas /////////////////////////////////////////////-->
            <!--///////////////////////////////////////////////////////////////////////////////////////////////////////-->
            
         </b-container> <!--///// FINAL - do container cabecalhointerativo-b //////////////////////////////////////////-->
    </div> <!--///// FINAL - Main DIV /////////////////////////////////////////////////////////////////////////////////-->
</template>

<script>
//import { userKey } from '../../global'
import { mapState } from 'vuex'
import { ekarApyaba } from '../../config/piht/cv.js'

export default {
    name: 'CabecalhoInterativo',
    components: { 
        Sinos: () => import(/* webpackChunkName: "cabecInterativo" */ "../efeitos/Sinos"),
        mainInfo: () => import(/* webpackChunkName: "cabecInterativo" */ "../efeitos/mainInfo"),
        inicioInterativo: () => import(/* webpackChunkName: "cabecInterativo" */ "../efeitos/InicioInterativo"), 
        avatarSmall: () => import(/* webpackChunkName: "cabecInterativoAvatarXS" */ "../efeitos/avatarSmall"),
    },
    props: { },
    computed: {
        ...mapState(['MenuVisivel', 'usuario']),
        limitaTitulo: function () {
            const entrada = this.usuario.nome_razao;
            let saida = '';

            if(entrada.length >= 32) {
                saida = entrada.substring(0, 31);
                saida += " ...";
            } else saida = entrada;
        
            return saida
        }
    },
    methods: {
        alternaMenuInterativo() {
            this.$store.commit('alternaMenu')
        },
        kesabAkanga() {
           ekarApyaba(this.usuario, this.$router.currentRoute.path);//executa acao de ctrl //////////
            if(this.$mq === 'xs' || this.$mq === 'sm' || this.$mq === 'md') {
                this.$nextTick(function () {
                    this.$store.commit('alternaMenu', false);
                });
            }
        }
    },
}
</script>

<style>
.cabecalhointerativo {
    /*grid-area: akanga;*/
    position: relative;
    height: 50px;
    width: 100%;
   /* background: linear-gradient(to right, #1e469a, #008fac);*/
    /*background: #008fac;*/
    background: #fff;
    /*box-shadow: 5px 5px 5px #2e2d2c;*/
    /*box-shadow: 5px 5px 5px #000, -5px 5px 5px #000;*/
}
.cabecalhointerativo-b {
    margin: 0;
}
.cab-int-l1 {
    margin: 0;
    height: 50px;
}

.abreMenuInterativo {
    width: 50px;
    height: 100%;
    margin-left: 10px;
}

.iconeSetaMenu {
    position: relative;
    color: #a6a6a6;
    font-size: 20px;
    text-align: center;
    padding-top: 8px;
    width: 50px;
    height: 36px;
    margin-top: 7px;
    border-radius: 4px;
    border: solid 1px;

    transition: color .4s ease-in-out,
    background-color .4s ease-in-out,
    border-color .4s ease-in-out,
    box-shadow .4s ease-in-out,
    -webkit-box-shadow .4s ease-in-out;
}

.iconeSetaMenu:hover {
    /*color: #000;*/
    background-color: rgba(0, 143, 172);
    cursor: pointer;
    color: white;
    border-color: #2e2d2c;
}

.cabecalhointerativo-titulo {
    position: absolute;
    max-width: 300px;
    height: 100%;
    font-size: 16px;
    color: #a0a0a0;
    font-family: "Play", sans-serif;
    top: 14px;
    margin-left: 5px;
}

.cab-int-bot {
    display: inline-block;
    height: 50px;
    width: 50px;
}


</style>